module.exports = __webpack_public_path__ + "static/media/img-profile-default.05ae1039.svg";